var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.type},[_c('shared-user',{attrs:{"type":_vm.type,"titles":_vm.titles,"staff-type":_vm.staffType}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }